import request from './adminRequest'

export const appliedJobApi = {
  listAllCourse (params) {
    return request.get('/allCourses/', { params: params })
  },
  updateSortNum (id, data) {
    return request.put('/allCourses/' + id, data)
  },

}
export default appliedJobApi
